import React from "react";
import ButtonComponent from "./ButtonComponent";

import { useTranslation } from "react-i18next";

function BoxText({ children, handleSaveButton }) {
  const { t } = useTranslation();

  if (!children) return null;
  return (
    <div className="content-box">
      <div className="box row">
        <div className="paragraph">{children}</div>
        <ButtonComponent
          classes="edit"
          children={t("buttons.saveChanges")}
          handleOnClick={handleSaveButton}
        />
      </div>
    </div>
  );
}

export default BoxText;
